import { DragDropItem } from '../types/item';
import { map } from 'rxjs/operators';
import { OperatorFunction } from 'rxjs';

type RankSelector<T> = (item: T) => string | number | null | undefined;

type NumericKeys<T> = {
  [K in keyof T]: T[K] extends number ? K : never;
}[keyof T];


export function orderByRank<Type extends DragDropItem>(
  list: Type[],
  order: 'asc' | 'desc' = 'asc'
): Type[] {
  const res = list
    .sort((a, b) => {
      if (a.rank < b.rank) {
        return -1;
      }
      if (a.rank > b.rank) {
        return 1;
      }
      return 0;
    })
    .map((item, index) => {
      item.rankNumber = index + 1;
      return item;
    });
  return order === 'asc' ? res : res.reverse();
}

export function orderByCustomRank<Type extends DragDropItem>(
  list: Type[],
  selector: RankSelector<Type>,
  rankField: NumericKeys<Type>,
  order: 'asc' | 'desc' = 'asc'
): Type[] {
  const multiplier = order === 'asc' ? 1 : -1;

  list.sort((a, b) => {
    const valA = selector(a);
    const valB = selector(b);
    if (valA == null && valB == null) { return 0; }
    if (valA == null) { return 1; }
    if (valB == null) { return -1; }

    if (valA < valB) {  return -1 * multiplier; }
    if (valA > valB) {  return 1 * multiplier; }
    return 0;
  });
  for (let i = 0; i < list.length; i++) {
    // @ts-ignore
    list[i][rankField] = i + 1;
  }
  return list;
}

export function orderByRankRxjs<Type extends DragDropItem>(
  order: 'asc' | 'desc' = 'asc'
): OperatorFunction<Type[], Type[]> {
  return map((list: Type[]) => {
    return orderByRank(list, order);
  });
}
